<template>
    <span  v-if="showReadyToBoardFlag(ride) == true">
        <b-button 
            variant="outline-default"
            v-b-tooltip.hover
            size="sm"
            content="Pasajero listo para abordar"
            v-tippy="{ arrow: true, arrowType: 'round' }"
            >
            <div class="bg"></div>
            <div class="button text-center text-white">
                <svg width="16" height="16" fill="currentColor" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 190" enable-background="new 0 0 256 190" xml:space="preserve">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier"> <path d="M48.12,27.903C48.12,13.564,59.592,2,74.023,2c14.339,0,25.903,11.564,25.903,25.903 C99.834,42.335,88.27,53.806,74.023,53.806C59.684,53.806,48.12,42.242,48.12,27.903z M191,139h-47V97c0-20.461-17.881-37-38-37H43 C20.912,60,1.99,79.14,2,98v77c-0.026,8.533,6.001,12.989,12,13c6.014,0.011,12-4.445,12-13v-75h8v88h78v-88h8l0.081,50.37 c-0.053,8.729,5.342,12.446,10.919,12.63h60C207.363,163,207.363,139,191,139z M218.447,62.043h13.387v66.5h-54.417v-66.5h13.3 v-9.562c0-3.477,3.129-5.65,6.78-5.65c-0.087,0,14.169,0,14.169,0c3.738,0,6.78,2.173,6.78,5.65V62.043z M213.492,52.22h-17.82 v9.823h17.82V52.22z M244.09,61.869h-7.302v66.587h7.302c5.042,0,9.91-3.738,9.91-10.171c0,0,0-46.158,0-46.332 C254,66.215,249.219,61.869,244.09,61.869z M165.16,128.456h7.302V61.869h-7.302c-5.129,0-9.91,4.346-9.91,10.084 c0,0.174,0,46.332,0,46.332C155.25,124.718,160.118,128.456,165.16,128.456z"></path></g>
                </svg>
            </div>
        </b-button>
        <small class="pt-1 mr-2">Hace {{ diffMinutes }}m |</small>
    </span>
</template>

<script>

export default {
    props: {
		ride: {
			type : Object,
			required: true
		},
	},
    data() {
        return {
            interval: null,
            diffMinutes: null
        }
    },
    methods: {
        showReadyToBoardFlag(ride) {
            if (ride.readyToBoard != null && this.diffMinutes < 60 && ride.status == 'active') {
                return true
            }
            return false
        },
        calculateElapsedTime() {
            const now         = new Date();
            const target      = new Date(this.ride.readyToBoard);
            const diffMs      = Math.abs(now - target);
            this.diffMinutes  = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        }
    },
    mounted() {
        //this.ride.readyToBoard = new Date('2025-01-24 17:00:00')
        this.interval = setInterval(() => {
            this.calculateElapsedTime()
        }, 1000)

    },
    beforeDestroy() {
        clearInterval(this.interval)
    }
}
</script>

<style>
    .bg, .button {
        width: 25px;
        height: 25px;
        border-radius: 100%;
    }

    .bg {
        animation: pulse 1.2s ease infinite;
        background: #ff3466;
        position: absolute;
    }

    .button {
        justify-content: center;
        align-items: center;
        z-index: 99;
        border: none;
        background: #ff3466;
        background-size: 18px;
        cursor: pointer;
        outline: none;
    }

    @keyframes pulse {
        0% {
            transform: scale(1, 1);
        }
        50% {
            opacity: 0.3;
        }
        100% {
            transform: scale(1.5);
            opacity: 0;
        }
    }
</style>